import type { ElementType, ReactNode } from 'react';
import { useSidebar } from '@src/app/layout';
import Link from '@src/shared/ui/Link';
import { ListItem, ListItemButton, ListItemText } from '@src/shared/ui/List';

export interface SidebarSubItemProps {
  label?: ReactNode;
  active?: boolean;
  component?: ElementType;
  [key: string]: unknown;
}

const StyleSheet = {
  listItemButton: {
    borderBottom: '1px solid',
    borderColor: 'grey.200',
    ml: '60px',
    padding: '3px 0',
    '&:hover, &.Mui-active': {
      backgroundColor: 'transparent',
      color: 'primary.main',
    },
  },
  listItemText: {
    m: 0,
    whiteSpace: 'nowrap',
  },
};

function SidebarSubItem(props: SidebarSubItemProps) {
  const { label, active, component, ...restProps } = props;

  const sidebar = useSidebar();
  if (!sidebar) {
    return null;
  }
  const { isExpanded } = sidebar;

  return (
    <>
      {isExpanded ? (
        <ListItem disablePadding>
          <ListItemButton
            sx={StyleSheet.listItemButton}
            className={active ? 'Mui-active' : undefined}
            component={component ?? Link}
            {...restProps}
          >
            <ListItemText
              disableTypography
              primary={label}
              sx={StyleSheet.listItemText}
            />
          </ListItemButton>
        </ListItem>
      ) : null}
    </>
  );
}

SidebarSubItem.displayName = 'SidebarSubItem';
export default SidebarSubItem;
